export default () => ({
  configs: [],
  listener: undefined,
  notifications: []
})
